module.exports = new __parcel__URL__("snare_7.a258b319.mp3").toString();